<template>
    <div class="enBusiness">
             <div class="order-header flex align-cen">
              <div class="header-container-left" @click="openGo">
                 <img src="../../assets/images/HeroopSys.png" alt="" class="sider-logo">
            </div>
               <div class="header-container-con"></div> 
            <div class="header-container-right mft" style="margin-right:24px">
                <el-dropdown>
                <span class="el-dropdown-link flex align-cen" style="color:#fff;cursor: pointer;">
                 <img :src="user.avatar || require('../../assets/images/head.png')" alt="" class="sider-logo">
                 {{user.name}}
                </span>
                </el-dropdown>
            </div>
        </div>
        <div class="enBusiness-module-wrap">
            <div class="enBusiness-module-box">
            <div class="enBusiness-module-title">
               <h2>选择主体公司</h2>
               <div class="title-info flex align-cen">
                <img :src="user.avatar || require('../../assets/images/head.png')" alt="" class="info-head">
                <div class="info">
                    <div class="name">{{user.name}}</div>
                     <div class="phone flex align-cen">
                        {{user.username}}
                        <div class="set" @click="openSet">
                            设置
                        </div>
                        <div class="logout" @click="logout">退出</div>
                        </div>
                </div>
               </div>
            </div>
            <div class="enBusiness-module-list">
                <div class="row flex align-cen">
                    <div class="itemInfo col-lg-4"
                     v-for="(item, index) in list" :key="index"
                     @click="openMan(item)"
                    >
                        <img :src="item.logo || require('../../assets/images/blogo.png')" alt="">
                        <div class="itemInfo-title">
                            <p>{{item.name}}</p>
                        </div>
                    </div>
                    <div style="height:50px"></div>
                </div>
            </div>
            </div>
        </div>
    </div>
</template>
<script>
import LocaStorage from "../../utils/localstorage.js"
import { enBusiness} from "@/api/enterprise/index" //查询企业列表
export default {
    name:'enBusiness',
    data () {
        return {
            user:{},
            lotoken:'',
            list:[]
        }
    },
    created(){
         document.title = "选择企业主体"
        const token1 = LocaStorage.setAge().get('token1')
       const userinfo1 = LocaStorage.setAge().get('userinfo1')
        this.user = userinfo1 
        this.lotoken = token1
         this.getInfo()
    },
    methods: {
        // 打开企业端
        openMan(data){
            localStorage.removeItem('businessInfo')
            LocaStorage.setAge().set('businessInfo',data)
            if(this.$route.query.currentNav1 || this.$route.query.currentNav1 == 0){
                 this.$router.push({
                name:'enCourseDetail',
                query:{
                     id:this.$route.query.id,
                     currentNav1:this.$route.query.currentNav1,
                }
            })
            }else{
             if(this.$util.isMobile()){
                // 手机点击进入后台时
                this.$router.push('/webenterprise/mobileCenter')
            }else{
                // pc点击进入后台时
            this.$router.push({
                name:'webenterpriseManage',
            })
            }
            }
            
        },
        // 获取企业列表
        getInfo(){
            enBusiness({},'enterprise')
           .then(res => {
           this.list = res.data
           })
           .catch(err => {
           })
        },
          // 返回上一层
        openGo(){
             this.$bus.$emit("isShow", true);
             this.$router.push('/webenterprise/homePage')
        },
        // 打开设置
        openSet(){
             const newurl = this.$router.resolve({name:'enSetting', query: {}})
                window.open(newurl.href,'_blank')
        },
        // 退出
        logout(){
             localStorage.removeItem('token1')
            localStorage.removeItem('userinfo1')
            localStorage.removeItem('businessInfo')
             this.$router.push('/webenterprise/homePage')
             this.$bus.$emit("tokenStatus", false);
        }
    },
}
</script>
<style lang="scss" scoped>
.enBusiness{
        .order-header{
    position: relative;
    background: #fff;
    height: 64px;
    position: relative;
   box-shadow: 0 2px 4px 0 rgb(0 0 0 / 10%);
      .header-container-left{
        line-height: 64px;
        height: 64px;
            margin-left: 24px;
             margin-right: 24px;
             img{
                width: 80px;
             }
     }
          .header-container-right{
        img{
                width: 30px;
            margin-right: 10px;
            border-radius: 50%;
            height: 30px;
        }
        .right-btn{
            height: 64px;
            margin-left: 24px;
             margin-right: 24px;
             color: #333;
             .right-login{
                margin-right: 24px;
                cursor: pointer;
             }
           .trial{
            padding: 10px 24px;
            
            color: #333;
            border-radius: 5px;
            cursor: pointer;
           } 
        }
     }
    }
    .enBusiness-module-wrap{
        margin-top: 20px;
        margin-bottom: 20px;
        font-size: 12px;
        min-width: 1000px;
        max-width: 1200px;
        margin-left: auto;
        margin-right: auto;
        zoom: 1;
        .enBusiness-module-box{
            padding: 0 40px;
        .enBusiness-module-title{
             padding-top: 20px;
                 h2{
            font-size: 14px;
            color: #373d41;
            font-weight: 700;
            position: relative;
            }
            h2::after{
                content: '';
                width: 85px;
                height: 2px;
                background: #155bd4;
                position: absolute;
                bottom: -10px;
                left: 0;
            }
            .title-info{
                padding: 30px;
                background:rgba(242, 242, 242, 1) ;
                margin:20px 0;
                border-radius: 5px;
                .info-head{
                    width: 50px;
                    height: 50px;
                    border-radius: 50%;
                }
                .info{
                    padding-left: 20px;
                    font-size: 14px;
                    .set,.logout{
                        padding-left: 10px;
                        color:red ;
                        cursor: pointer;
                    }
                }
            }
        }
        .enBusiness-module-list{
            
            .row{
                flex-wrap: wrap;
                .itemInfo{
                    border: 1px solid #dcdcdc;
                    margin-right: 30px;
                    padding: 52px 24px 72px 24px;
                    border-radius: 5px;
                    max-width: 376px;
                    flex: 0 0 26%;
                    cursor: pointer;
                    margin-bottom:24px ;
                    img{
                        text-align: center;
                        margin: auto;
                        display: block;
                        width: 60px;
                        height: 60px;
                        border-radius: 50%;
                        object-fit: cover;
                    }
                    .itemInfo-title{
                    font-size: 16px;
                    line-height: 28px;
                    color: #666;
                    text-align: center;
                    padding-top: 30px;
                    }
                }
                .itemInfo:hover{
                    border-color: #4a77ed;
                }
            }
        }
        }
    }
}
::v-deep{
    .el-dropdown-link {
        color: #333 !important;
    }
    #helpDetail{
        overflow-y:  scroll !important;;
        height: auto !important;
    }
}
@media (max-width: 640px){
    .enBusiness{
        margin-top: -56px;
    }
    .enBusiness-module-wrap{
        min-width: 100% !important;
        max-width: 100%;
        .row{
            display: block !important;
            .itemInfo{
                max-width: 100% !important;
                margin-right: 0 !important;
            }
        }
    }
}
</style>    